<template>
    <!-- Endorsement wording starts -->
    <div class="row bgc-wrapper pl-0 mr-4 pr-3 col-12">
    <div class="collapse show mt-5 py-0 border parentRadius col-12 bgc-form-box ">
      <div class="risk row">
        <div
          class="form-group text-lg-left text-md-left text-center border-secondary m-0 px-0 pb-2 col-lg-10 col-md-10 col-sm-12"
        >
          <p class="mb-0  pt-md-4 pt-sm-2 pl-lg-5 pt-4 pl-md-5 pl-sm-0">{{planData.planName}}</p>
          <h5 class="mb-0 pl-lg-5 pl-md-5 pl-sm-0 pt-2 pb-0">{{(endorsementTypes.find(endrsType => endrsType.code == endorsementData.endorsement.endorsementType.value)).name}}</h5>
        </div>
        <!-- <div class="form-group text-lg-right text-md-right text-center child-radius text-white bg-dark mt-0 mb-0 pt-3 pr-3 
        col-lg-2 col-md-2 col-sm-12 p-0" v-if="endorsementData.endorsement.endorsementType.value=='nonNilCorrCustomerDetail'">
          <h4 class="mb-1 ml-4 ml-md-0 ml-lg-0 pl-5 pl-lg-0 pl-md-0">₹4,200</h4>
          <p class="mb-0 pl-5 pl-md-0 pl-lg-0 pb-4 pb-md-0 pb-lg-0">ADDITIONAL PREMIUM</p>
          <p class="mb-2 pl-5 pl-md-0 pl-lg-0 pb-4 pb-md-0 pb-lg-0"><span class="border-bottom">Show Breakup</span></p>
        </div> -->
         <div class="form-group text-lg-right text-md-right text-center child-radius text-white mt-0 mb-0 pt-md-2 pt-sm-2 pt-lg-3 pr-3 
        col-lg-2 col-md-2 col-sm-12 p-0" v-if="endorsementData.endorsement.endorsementType.value">
          <h5 class="mb-1 ml-md-0 ml-lg-0 pl-3">₹ {{refundAmount ? refundAmount : planData.outstandingPremium}}</h5>
          <p class="mb-0 pl-3 pl-md-0 pl-lg-0 pb-0">{{premiumType}}</p>
          <p class="mb-2 pl-3 pl-md-0 pl-lg-0 pb-0"><span class="border-bottom breakup-cursor" @click="showBreakupModal()">Show Breakup</span></p>
        </div>
      </div>
      <div class="risk row">
        <div class="form-group mb-4 mt-2 pl-5 col-lg-12 col-md-12 col-sm-12 p-0" v-if="displayWordings">
          <p class="font-weight-bold mb-0 text-secondary">Endorsement wording*</p>
          <p class="mt-2 mr-5 pl-3 pt-2 pr-5 pb-4 border rounded" v-for="wording in endorsementWordings" :key="wording.wordings">{{wording.wordings}}</p>
        </div>
      </div>
    </div>
    <!--Endorsement wording ends -->
    <PremiumBreakdownModal v-show="state.premiumBreakDownModal" :showModal="state.premiumBreakDownModal" :calcbasePremium="calcbasePremium" :premcalcDetail="premcalcDetail" :taxDetails="taxDetails" :premiumType="premiumType"/>
    </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import PremiumBreakdownModal from "../modals/PremiumBreakdownModal.vue";
import { reactive } from '@vue/composition-api';
export default {
  name: "EndorsementWording",
  props: ["endorsementData","endorsementTypes","planData",'endorsementWordings','displayWordings','premiumType','refundAmount','premcalcDetail','calcbasePremium','taxDetails'],
  components: {
    FloatLabel,
    PremiumBreakdownModal
  },
  setup(props , { parent, root }){
    let state = reactive({
      premiumBreakDownModal: false
    });
    function breakdownModal(){
      state.premiumBreakDownModal = false;
    }
    function showBreakupModal(){
      state.premiumBreakDownModal = true;
    }
    return{
      state,
      breakdownModal,
      showBreakupModal
    }
  }
};
</script>

<style scoped>
.child-radius{
  background: #0070be;
}
.breakup-cursor{
  cursor: pointer;
}
@media screen and (min-width: 768px) {
  .parentRadius {
    border-radius: 15px;
  }
  .child-radius {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
}
@media screen and (min-width: 280px) and (max-width: 767px) {
  .parentRadius {
    border-radius: 15px;
  }
  .child-radius {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
}
</style>